import { useSelectedFacilityId } from '@/hooks/useFacilitiesQuery';
import { FacilitySettingsSettings } from '@/types/crm-screener-api';

import { useFacilitySettingsQuery } from './useFacilitySettingsQuery';

export function useGetFacilitySettingValue<
  K extends keyof FacilitySettingsSettings
>(settingKey: K, facilityId?: string) {
  const selectedFacilityId = useSelectedFacilityId();
  const effectiveFacilityId = facilityId ?? selectedFacilityId;

  const { data: facilitySettings, isLoading } =
    useFacilitySettingsQuery().useGetFacilitySettings(effectiveFacilityId!);

  return {
    value: facilitySettings?.settings?.[settingKey],
    isLoading
  };
}
